import React from "react"
export default function Main(){
    return(
        <div >
            <div className="Main">
            <img className="streamify-logo" src="./streamify.png" />
            <h1 className="site-title">Streamify</h1>
            <img className="streamify-bimage" src="./main.jpg" alt="Streamifyy"/>
            </div>
            
            <h3 className="streamify-caption"><span className="streamify">Streamify</span>: Stream your favorite shows and movies, anytime, anywhere.</h3>
        </div>
    )
}